export const COLORS = {
  WHITE: '#FFFFFF',
  PRIMARY: '#15A759',
  ACCENT: '#F4E824',
  BORDER: '#808080',
  TEXT: '#333333',
  TEXT_LIGHT: '#666666'
};

export const API_BASE_URL = process.env.REACT_APP_API_URL;